import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-validation-toast',
  imports: [TranslateModule],
  templateUrl: './validation-toast.component.html',
  styleUrl: './validation-toast.component.css',
})
export class ValidationToastComponent {}
